import axios from 'axios';
import { resolveTenantFromUrl } from '@low6-pickem/frontend-shared';
import { getStoredToken, clearAuthData } from '../utils/auth';
import { initiateOAuthLogin } from '../utils/oauth';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';
const TENANT_SLUG = resolveTenantFromUrl();

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
    'X-Tenant-Slug': TENANT_SLUG,
  },
});

apiClient.interceptors.request.use(config => {
  const token = getStoredToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let isOAuthRedirectPending = false;

apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      if (isOAuthRedirectPending) return Promise.reject(error);

      const isCallback =
        window.location.pathname.endsWith('/auth/callback') ||
        window.location.hash.includes('/auth/callback');
      if (isCallback) return Promise.reject(error);

      const storedToken = getStoredToken();
      if (storedToken) {
        clearAuthData();
        return Promise.reject(error);
      }

      clearAuthData();
      isOAuthRedirectPending = true;
      initiateOAuthLogin().catch(() => {
        isOAuthRedirectPending = false;
      });
    }
    return Promise.reject(error);
  }
);
